function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabsArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tabs_arrow_right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z",
    transform: "rotate(-90 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.351 375.692-.659-.659 5.341-5.341-5.341-5.341.659-.659 6 6z",
    transform: "translate(-351.646 -357.692)",
    style: {
      fill: "#08232f"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabsArrowRight);
export default __webpack_public_path__ + "static/media/tabs_arrow_right.be89298fe8b0ac9f2520a35e50a03246.svg";
export { ForwardRef as ReactComponent };